var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOceanViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4165",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.5001V32H0.5V1Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4749 24.1939L31.1614 27.2875",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6749 22.3998C21.9856 21.2723 24.6786 21.4469 26.7988 22.7626",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.931 19.9197L13.3249 18.9982C11.281 17.8254 8.69292 18.2626 7.14785 20.0419L5.09998 22.4",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67711 24.032L0.849976 27.2875H27.7685L16.8034 20.9957",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32495 27.2875L14.0207 24.2334C14.7549 23.756 15.7006 23.752 16.4387 24.2234L21.2384 27.2875",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5375 27.2875H0.474976",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9794 14.5103C24.9794 15.6713 24.0381 16.6125 22.8771 16.6125C21.716 16.6125 20.7749 15.6713 20.7749 14.5103C20.7749 13.3493 21.716 12.408 22.8771 12.408C24.0381 12.408 24.9794 13.3493 24.9794 14.5103Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8749 10.0851V9.74016",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8749 19.2773V18.9323",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.025 11.3789L26.2689 11.135",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.8813L19.7438 17.6373",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 14.5086H27.645",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 14.5086H18.47",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.025 17.6373L26.2689 17.8813",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.135L19.7438 11.3789",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30752 11.2368H4.05995C3.44689 11.2368 2.94995 11.7338 2.94995 12.3468C2.94995 12.9598 3.44689 13.4568 4.05995 13.4568H13.4005C13.8974 13.4568 14.3002 13.8596 14.3002 14.3566C14.3002 14.8534 13.8974 15.2563 13.4005 15.2563H4.99502",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4312 5.71181H19.9074C20.5204 5.71181 21.0173 6.20875 21.0173 6.82181C21.0173 7.43482 20.5204 7.93181 19.9074 7.93181H11.8747C11.3778 7.93181 10.975 8.33462 10.975 8.8315C10.975 9.32837 11.3778 9.73125 11.8747 9.73125H15.3423",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 24.9514L6.72367 25.2374",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2263 24.951L8.09998 25.2374",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 22.2389L11.7487 22.525",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2763 22.2362L13.15 22.5227",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceanViews);
export default __webpack_public_path__ + "static/media/ocean_views.e17b6f12676e8bc0f88bf3a75fed1a2b.svg";
export { ForwardRef as ReactComponent };